"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var ViewStudentDetailsModalController = /** @class */ (function () {
    function ViewStudentDetailsModalController($uibModalInstance, student, UsersModel, preferred_pronoun_enabled) {
        var _this = this;
        this.$uibModalInstance = $uibModalInstance;
        this.UsersModel = UsersModel;
        this.student = {};
        this.nextSession = {};
        this.hasNextSession = false;
        this.loading = true;
        this.preferred_pronoun_enabled = preferred_pronoun_enabled;
        UsersModel.getStudentByID(student.id)
            .then(function (response) {
            //this.student = response.student;
            if (response.usermeta.permit) {
                response.usermeta.permit.issuedate = (0, time_1.parseDate)(response.usermeta.permit.issuedate);
                response.usermeta.permit.expirationdate = (0, time_1.parseDate)(response.usermeta.permit.expirationdate);
            }
            var student = response;
            _this.student = student;
            _this.loading = false;
            _this.getNextSession();
        })
            .catch(function (error) {
            _this.loading = false;
        });
    }
    ViewStudentDetailsModalController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss("cancel");
    };
    ViewStudentDetailsModalController.prototype.getNextSession = function () {
        var _this = this;
        this.UsersModel.getNextStudentEntity({ id: this.student.id }).then(function (response) {
            if ((0, isEmpty_1.default)(response.entity)) {
                _this.nextSession = {};
                _this.hasNextSession = false;
            }
            else {
                _this.nextSession = {
                    nextDrive: response.entity,
                    nextDriveDate: (0, time_1.dateTimeStringToDate)(response.entity.date + " " + response.entity.time),
                    untilDrive: (0, time_1.formatDateTime)((0, time_1.dateTimeStringToDate)(response.entity.date + " " + response.entity.time), "h:mm A"),
                };
                _this.hasNextSession = true;
            }
        });
    };
    return ViewStudentDetailsModalController;
}());
ViewStudentDetailsModalController.$inject = [
    "$uibModalInstance",
    "student",
    "UsersModel",
    "preferred_pronoun_enabled",
];
exports.default = ViewStudentDetailsModalController;
